// extracted by mini-css-extract-plugin
module.exports = {"about-section":"About_about-section__nRtnX","about-paragraph":"About_about-paragraph__3qLTF"};